import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { BaseLocCalculatorComponent } from '../base/base-loc-calculator.component';
import { ActivatedRoute } from '@angular/router';
import { AppBarTitleService, OfferCalculatorService, ProductCode } from 'common';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from '../../../app.settings';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { ApplicationService } from '../../shared/application.service';

@UntilDestroy()
@Component({
    selector: 'ifa-loc-calculator',
    templateUrl: './loc-calculator.component.html',
    styleUrls: ['./../base/base-calculator.component.scss', './loc-calculator.component.scss'],
    standalone: false
})
export class LocCalculatorComponent extends BaseLocCalculatorComponent {

    constructor(
        route: ActivatedRoute,
        sanitizer: DomSanitizer,
        appBarTitleService: AppBarTitleService,
        calculatorService: OfferCalculatorService,
        applicationService: ApplicationService,
        settings: AppSettings,
        percentPipe: PercentPipe,
        currencyPipe: CurrencyPipe
      ) {

        super(route, sanitizer, appBarTitleService, calculatorService, applicationService, settings, percentPipe, currencyPipe);
    }

    ngAfterContentInit(): void {
        this.setAppBarTitle('See all products');
    // @ts-ignore - TODO: Refactor to align with "@types/lodash" typings - RYNO-12167
    this._calculatorService.bundleChanged.pipe(untilDestroyed(this)).subscribe(bundle => this.offer = _.first(bundle?.offers, { productCode: ProductCode.LOC }));
    }


}
